










































































































































import WidgetsList from '@/interfaces/WidgetsList';
import { default as Component } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Basic from './Basic.vue';

@Component({})
export default class StepperWidget extends Basic {
  @Prop() public stepperState!: WidgetsList;
  public showMobileList = false;

  public goToWidget(widgetName: string): void {
    this.showMobileList = false;
    this.$emit('goToWidget', widgetName);
  }
}
